"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.mapDispatchToCodeBenchProps = exports.mapStateToCodeBenchProps = void 0;
//import { push } from 'connected-react-router';
var ui_common_1 = require("@codametrix/ui-common");
var utils_1 = require("../../utils/utils");
var _a = ui_common_1.AmplifyCore.actions, getInvoiceOptions = _a.getInvoiceOptions, removeTransaction = _a.removeTransaction, providerSearch = _a.providerSearch;
var addImprovement = ui_common_1.improvementActions.addImprovement, removeImprovement = ui_common_1.improvementActions.removeImprovement, improvementSearch = ui_common_1.improvementActions.improvementSearch, updateImprovement = ui_common_1.improvementActions.updateImprovement, addImprovementProvider = ui_common_1.improvementActions.addImprovementProvider, updateImprovementProvider = ui_common_1.improvementActions.updateImprovementProvider, removeImprovementProvider = ui_common_1.improvementActions.removeImprovementProvider;
var dismissConfirm = ui_common_1.uiActions.dismissConfirm, handleConfirm = ui_common_1.uiActions.handleConfirm, showConfirm = ui_common_1.uiActions.showConfirm, hideFeedback = ui_common_1.uiActions.hideFeedback, amplifyFeedback = ui_common_1.uiActions.amplifyFeedback;
var loadCaseFromId = ui_common_1.launchPageActions.loadCaseFromId, loadFromURLMatch = ui_common_1.launchPageActions.loadFromURLMatch;
var cancelInvoicesPopup = ui_common_1.codeBenchActions.cancelInvoicesPopup, clearSearchResults = ui_common_1.codeBenchActions.clearSearchResults, codeAdd = ui_common_1.codeBenchActions.codeAdd, codesAdd = ui_common_1.codeBenchActions.codesAdd, createTransactionAndAddCode = ui_common_1.codeBenchActions.createTransactionAndAddCode, codeRemove = ui_common_1.codeBenchActions.codeRemove, codesRemove = ui_common_1.codeBenchActions.codesRemove, timeBasedCodeAdd = ui_common_1.codeBenchActions.timeBasedCodeAdd, timeBasedCodeUpdate = ui_common_1.codeBenchActions.timeBasedCodeUpdate, codeSearch = ui_common_1.codeBenchActions.codeSearch, codeSearchDrop = ui_common_1.codeBenchActions.codeSearchDrop, codeUpdate = ui_common_1.codeBenchActions.codeUpdate, featureSelection = ui_common_1.codeBenchActions.featureSelection, fetchProcessInstance = ui_common_1.codeBenchActions.fetchProcessInstance, navigateDetail = ui_common_1.codeBenchActions.navigateDetail, popupClose = ui_common_1.codeBenchActions.popupClose, popupNavigate = ui_common_1.codeBenchActions.popupNavigate, promptClose = ui_common_1.codeBenchActions.promptClose, selectInvoiceToEdit = ui_common_1.codeBenchActions.selectInvoiceToEdit, selectInvoiceToAdd = ui_common_1.codeBenchActions.selectInvoiceToAdd, submitInvoice = ui_common_1.codeBenchActions.submitInvoice, openAddChargeModal = ui_common_1.codeBenchActions.openAddChargeModal, closeAddChargeModal = ui_common_1.codeBenchActions.closeAddChargeModal, addTransaction = ui_common_1.codeBenchActions.addTransaction, submittedFeedbackTimer = ui_common_1.codeBenchActions.submittedFeedbackTimer, deleteSizeExpWarning = ui_common_1.codeBenchActions.deleteSizeExpWarning, hideSubmittedFeedback = ui_common_1.codeBenchActions.hideSubmittedFeedback, txnSharedCodeAction = ui_common_1.codeBenchActions.txnSharedCodeAction, enableTechPro = ui_common_1.codeBenchActions.enableTechPro, disableTechPro = ui_common_1.codeBenchActions.disableTechPro, hidevitalwareIssuesModal = ui_common_1.codeBenchActions.hidevitalwareIssuesModal, showHoldCaseModal = ui_common_1.codeBenchActions.showHoldCaseModal, hideHoldCaseModal = ui_common_1.codeBenchActions.hideHoldCaseModal, showCaseCommentModal = ui_common_1.codeBenchActions.showCaseCommentModal, hideCaseCommentModal = ui_common_1.codeBenchActions.hideCaseCommentModal, showExclusionCaseModal = ui_common_1.codeBenchActions.showExclusionCaseModal, hideExclusionCaseModal = ui_common_1.codeBenchActions.hideExclusionCaseModal, showSplitCaseModal = ui_common_1.codeBenchActions.showSplitCaseModal, hideSplitCaseModal = ui_common_1.codeBenchActions.hideSplitCaseModal, navigate = ui_common_1.codeBenchActions.navigate, toggleChargeableCase = ui_common_1.codeBenchActions.toggleChargeableCase, navigatePatient = ui_common_1.codeBenchActions.navigatePatient, navigateProvider = ui_common_1.codeBenchActions.navigateProvider, holdCase = ui_common_1.codeBenchActions.holdCase, toggleSubmitOldCaseModal = ui_common_1.codeBenchActions.toggleSubmitOldCaseModal, getCaseVersions = ui_common_1.codeBenchActions.getCaseVersions, openWindow = ui_common_1.codeBenchActions.openWindow, loadCursorAPIContext = ui_common_1.codeBenchActions.loadCursorAPIContext, loadRoles = ui_common_1.codeBenchActions.loadRoles, getFlagItems = ui_common_1.codeBenchActions.getFlagItems, getCasesWithEncounter = ui_common_1.codeBenchActions.getCasesWithEncounter, setActiveNote = ui_common_1.codeBenchActions.setActiveNote, setActiveMiniTab = ui_common_1.codeBenchActions.setActiveMiniTab, setActiveVerticalMiniTab = ui_common_1.codeBenchActions.setActiveVerticalMiniTab, setUnresolvedDocuments = ui_common_1.codeBenchActions.setUnresolvedDocuments, navigateCoderNotes = ui_common_1.codeBenchActions.navigateCoderNotes, removeInvoice = ui_common_1.codeBenchActions.removeInvoice;
var navigateCreateCase = ui_common_1.createCaseActions.navigateCreateCase;
var showMergeCasesModal = ui_common_1.mergeCasesActions.showMergeCasesModal, hideMergeCasesModal = ui_common_1.mergeCasesActions.hideMergeCasesModal, fetchMergeableCases = ui_common_1.mergeCasesActions.fetchMergeableCases, splitCase = ui_common_1.mergeCasesActions.splitCase;
var showAttachDocsModal = ui_common_1.attachDocsActions.showAttachDocsModal;
var _b = ui_common_1.caseEditsActions.caseEditsActions, updateValue = _b.updateValue, updateCase = _b.updateCase, loadAllPatientDetailOptions = _b.loadAllPatientDetailOptions;
var ui_common_2 = require("@codametrix/ui-common");
exports["default"] = {
    ampUI: __assign({}, ui_common_1.AmplifyCore.state.ampUI),
    invoiceMetadata: __assign({}, ui_common_1.AmplifyCore.state.invoiceMetadata),
    codeBench: __assign({}, ui_common_1.AmplifyCore.state.codeBenchState),
    launch: __assign({}, ui_common_1.AmplifyCore.state.launch),
    eula: __assign({}, ui_common_2.AmplifyState),
    capabilities: __assign({}, ui_common_1.AmplifyCore.state.capabilities),
    improvements: __assign({}, ui_common_1.AmplifyCore.state.improvements)
};
// state : AmplifyDefaultState
var mapStateToCodeBenchProps = function (state) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var location_state = (_b = (_a = state === null || state === void 0 ? void 0 : state.router) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.state;
    var cursorAPIContext = location_state
        ? __assign({}, location_state) : __assign({}, ui_common_1.AmplifyCore.state.capabilities.cursorAPIContext);
    return __assign(__assign(__assign({}, state.codeBench), state.ampUI), { capabilities: state.capabilities, improvements: state.improvements, caseEdits: (_c = state.caseEdits) === null || _c === void 0 ? void 0 : _c.caseEdits, cursorAPIContext: cursorAPIContext, htmlNotes: (_e = (_d = state === null || state === void 0 ? void 0 : state.cases) === null || _d === void 0 ? void 0 : _d.htmlNotes) !== null && _e !== void 0 ? _e : (_f = state === null || state === void 0 ? void 0 : state.codeBench) === null || _f === void 0 ? void 0 : _f.htmlNotes, roles: (_h = (_g = state === null || state === void 0 ? void 0 : state.cases) === null || _g === void 0 ? void 0 : _g.roles) !== null && _h !== void 0 ? _h : [], caseRun: (_j = state === null || state === void 0 ? void 0 : state.cases) === null || _j === void 0 ? void 0 : _j.activeItem, caseAccessTime: (_k = state === null || state === void 0 ? void 0 : state.codeBench) === null || _k === void 0 ? void 0 : _k.caseAccessTime, customClaimsRelatedCases: (_l = state === null || state === void 0 ? void 0 : state.codeBench) === null || _l === void 0 ? void 0 : _l.customClaimsRelatedCases, customClaimsRelatedCasesLoadState: (_m = state === null || state === void 0 ? void 0 : state.codeBench) === null || _m === void 0 ? void 0 : _m.customClaimsRelatedCasesLoadState, backToWorklistPath: state.ui.backToWorklistPath, propertyConfig: (_o = state === null || state === void 0 ? void 0 : state.codeBench) === null || _o === void 0 ? void 0 : _o.propertyConfig });
};
exports.mapStateToCodeBenchProps = mapStateToCodeBenchProps;
var mapDispatchToCodeBenchProps = function (dispatch) {
    var runDispatchable = (0, utils_1.buildDispatchable)(dispatch);
    var debouncedFunc;
    return {
        setUnresolvedDocuments: function (value) {
            dispatch(setUnresolvedDocuments(value));
        },
        setActiveMiniTab: function (activeTabName) {
            dispatch(setActiveMiniTab(activeTabName));
        },
        setActiveVerticalMiniTab: function (activeVerticalTabName) {
            dispatch(setActiveVerticalMiniTab(activeVerticalTabName));
        },
        onProviderSearch: function (query) {
            dispatch(providerSearch(query));
        },
        handleConfirm: function (actionItem) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(actionItem.action === 'DELETE_TRANSACTION')) return [3 /*break*/, 2];
                        return [4 /*yield*/, dispatch(removeTransaction(actionItem))];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        dispatch(handleConfirm(actionItem));
                        return [2 /*return*/];
                }
            });
        }); },
        handleConfirmDismiss: function (actionItem) {
            dispatch(dismissConfirm(actionItem));
        },
        onLoadFromURLMatch: function (params) {
            runDispatchable(function () { return loadFromURLMatch(params); });
        },
        loadWorkItemDetails: function (case_uid, caserun_uid) { },
        onSearchClear: function (codeQuery, searchResultsLookupKey) {
            var _a, _b, _c;
            var searchId = (_c = (_b = (_a = codeQuery.context) === null || _a === void 0 ? void 0 : _a.chargeSession) === null || _b === void 0 ? void 0 : _b.transactionId) !== null && _c !== void 0 ? _c : '';
            dispatch(clearSearchResults(searchId));
            if (searchResultsLookupKey) {
                dispatch(clearSearchResults(searchResultsLookupKey));
            }
        },
        onFeatureActivation: function (selection) {
            dispatch(featureSelection(selection));
        },
        onCodeSearch: function (codeQuery) {
            dispatch(codeSearch(codeQuery));
        },
        onChargeSessionAction: function (transactionAction) {
            dispatch(showConfirm(transactionAction));
            //;
        },
        onCodeSearchSelection: function (searchSelection) {
            // codes are added through search selection
            dispatch(codeAdd(searchSelection));
        },
        handleAddAllCodes: function (searchSelection) {
            dispatch(codesAdd(searchSelection));
        },
        handleRemoveAllCodes: function (codeChange) {
            dispatch(codesRemove(codeChange));
        },
        createTransactionAndAddCode: function (searchSelection) {
            dispatch(createTransactionAndAddCode(searchSelection));
        },
        onPopUpNavigate: function (caseNavigate) {
            if (caseNavigate.replace) {
                dispatch(loadCaseFromId({ caseId: caseNavigate.caseId }));
            }
            else {
                sessionStorage.setItem('channel', ui_common_1.authenticationChannel.name);
                dispatch(popupNavigate(caseNavigate));
            }
        },
        onCodeUpdate: function (changeDetail) {
            dispatch(codeUpdate(changeDetail));
        },
        onCodeRemove: function (changeDetail) {
            dispatch(codeRemove(changeDetail));
        },
        onTimeBasedCodeAdd: function (codeChange, time, age) {
            dispatch(timeBasedCodeAdd({ codeChange: codeChange, time: time, age: age }));
        },
        onTimeBasedCodeUpdate: function (codeChange, time, age) {
            dispatch(timeBasedCodeUpdate({ codeChange: codeChange, time: time, age: age }));
        },
        onCodeSearchDrop: function (changeDetail) {
            dispatch(codeSearchDrop(changeDetail));
        },
        onModalAddChargeOpen: function () {
            dispatch(openAddChargeModal());
        },
        onModalAddChargeClose: function (e) {
            e.preventDefault();
            dispatch(closeAddChargeModal());
        },
        handleAddCharge: function (newInvoice) {
            dispatch(addTransaction(newInvoice));
        },
        handleTimer: function () {
            setTimeout(function () {
                dispatch(submittedFeedbackTimer());
            }, 700);
        },
        onInvoiceEdit: function (invoice, processInstance) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(getInvoiceOptions(processInstance))];
                    case 1:
                        _a.sent();
                        dispatch(selectInvoiceToEdit(invoice));
                        return [2 /*return*/];
                }
            });
        }); },
        onInvoiceAddition: function (invoice, processInstance) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(getInvoiceOptions(processInstance))];
                    case 1:
                        _a.sent();
                        dispatch(selectInvoiceToAdd(invoice));
                        return [2 /*return*/];
                }
            });
        }); },
        onInvoiceRemove: function (invoiceDeleteParams) {
            dispatch(removeInvoice(invoiceDeleteParams));
        },
        onLoad: function (caseRun) {
            dispatch(fetchProcessInstance(caseRun));
        },
        onPrompt: function (action) {
            dispatch(promptClose());
        },
        onPopUpClose: function () {
            dispatch(popupClose());
        },
        showPatientInfo: function (caseRun) {
            dispatch(navigatePatient(caseRun));
        },
        showProviderInfo: function (providerInfo) {
            dispatch(navigateProvider(providerInfo));
        },
        showCoderNotesInfo: function (coderNotesParams) {
            dispatch(navigateCoderNotes(coderNotesParams));
        },
        handleTraversal: function (caseDescriptor) {
            dispatch(navigateDetail(caseDescriptor));
        },
        onInvoicesCancel: function (processInstance) {
            dispatch(cancelInvoicesPopup(processInstance));
        },
        onInvoicesSubmisson: function (submission) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // This will submit the invoices.  At this point, the case
                    // is no longer codable.
                    return [4 /*yield*/, dispatch(submitInvoice(submission))];
                    case 1:
                        // This will submit the invoices.  At this point, the case
                        // is no longer codable.
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        onTransactionSharedDiagnosisChange: function (changeDetail) {
            dispatch(txnSharedCodeAction(changeDetail));
        },
        // Inactive methods at the moment.  They're required bc of the amount that
        // we're leveraging the case detail.
        onCaseAction: function (action) { },
        onFeatureSelection: function (selection) { },
        openChildWindow: function (windowOpenArgs) {
            dispatch(openWindow(windowOpenArgs));
        },
        openAmplifyCase: function (amplifyLaunchConfig) {
            dispatch(navigate("/cmx/worklist/".concat(amplifyLaunchConfig.serviceLine, "/case/").concat(amplifyLaunchConfig.caseId, "/case-run/").concat(amplifyLaunchConfig.id, "/")));
        },
        toggleArtifacts: function (showAll) { },
        showList: function (serviceLine, refreshList) { },
        onNavigate: function (caseId, replace) { },
        setActiveProcess: function (activeProcess) { },
        hideFeedback: function () {
            dispatch(hideFeedback());
        },
        deleteSizeExpWarning: function () {
            dispatch(deleteSizeExpWarning());
        },
        hideSubmittedFeedback: function () {
            dispatch(hideSubmittedFeedback());
        },
        handleEnableTechPro: function (transactionCodeChange) {
            dispatch(enableTechPro(transactionCodeChange));
        },
        handleDisableTechPro: function (transactionCodeChange) {
            dispatch(disableTechPro(transactionCodeChange));
        },
        hidevitalwareIssuesModal: function () {
            dispatch(hidevitalwareIssuesModal());
        },
        showHoldCaseModal: function () {
            dispatch(showHoldCaseModal());
        },
        hideHoldCaseModal: function () {
            dispatch(hideHoldCaseModal());
        },
        showCaseCommentModal: function () {
            dispatch(showCaseCommentModal());
        },
        hideCaseCommentModal: function () {
            dispatch(hideCaseCommentModal());
        },
        showExclusionCaseModal: function () {
            dispatch(showExclusionCaseModal());
        },
        hideExclusionCaseModal: function () {
            dispatch(hideExclusionCaseModal());
        },
        showSplitCaseModal: function () {
            dispatch(showSplitCaseModal());
        },
        hideSplitCaseModal: function () {
            dispatch(hideSplitCaseModal());
        },
        splitCase: function (processInstance) {
            dispatch(splitCase(processInstance));
        },
        toggleChargeableCase: function (toggleChargeableCaseObject) {
            dispatch(toggleChargeableCase(toggleChargeableCaseObject));
        },
        holdCase: function (holdCaseObject) {
            dispatch(holdCase(holdCaseObject));
        },
        onDocumentImprovementAdd: function (improvementRequest) {
            dispatch(addImprovement(improvementRequest));
        },
        onDocumentImprovementRemove: function (improvementRequest) {
            dispatch(removeImprovement(improvementRequest));
        },
        onDocumentImprovementSearch: function (codeQuery) {
            dispatch(improvementSearch(codeQuery));
        },
        onDocumentImprovementUpdate: function (documentImprovement) {
            dispatch(updateImprovement(documentImprovement));
        },
        onProviderAdd: function (improvementRequest) {
            dispatch(addImprovementProvider(improvementRequest));
        },
        onProviderUpdate: function (improvementRequest) {
            dispatch(updateImprovementProvider(improvementRequest));
        },
        onProviderRemove: function (documentImprovement) {
            dispatch(removeImprovementProvider(documentImprovement));
        },
        showAmplifyFeedback: function (feedback) {
            dispatch(amplifyFeedback(feedback));
        },
        updateValue: function (updatedFieldAndValue) {
            dispatch(updateValue(updatedFieldAndValue));
        },
        updateCase: function (updatesAndInfo) {
            dispatch(updateCase(updatesAndInfo));
        },
        navigate: function (url) {
            dispatch(navigate(url));
        },
        toggleSubmitOldCaseModal: function () {
            dispatch(toggleSubmitOldCaseModal());
        },
        getCaseVersions: function (processInstance) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(getCaseVersions(processInstance))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        onCursorAction: function (cursorAPIPayload) { },
        loadServicedeskContext: function (cursorAPIContext) {
            dispatch(loadCursorAPIContext(cursorAPIContext));
        },
        loadRoles: function (roles) {
            dispatch(loadRoles(roles));
        },
        loadAllPatientDetailOptions: function (tenantId) {
            dispatch(loadAllPatientDetailOptions(tenantId));
        },
        getFlagItems: function (activeItem) {
            dispatch(getFlagItems(activeItem));
        },
        getCasesWithEncounter: function (harListPayload) {
            dispatch(getCasesWithEncounter(harListPayload));
        },
        showMergeCasesModal: function (mergeCaseModalProps) {
            dispatch(showMergeCasesModal(mergeCaseModalProps));
        },
        navigateCreateCase: function (caseRun) {
            dispatch(navigateCreateCase(caseRun));
        },
        showAttachDocsModal: function (caseRun) {
            dispatch(showAttachDocsModal(caseRun));
        },
        hideMergeCasesModal: function () {
            dispatch(hideMergeCasesModal());
        },
        fetchMergeableCases: function (mergeableCasesParams) {
            dispatch(fetchMergeableCases(mergeableCasesParams));
        },
        setActiveNote: function (activeNote) {
            dispatch(setActiveNote(activeNote));
        },
        hideSideNavBar: function () {
            dispatch(ui_common_1.codeBenchActions.hideSideNavBar());
        },
        showSideNavBar: function () {
            dispatch(ui_common_1.codeBenchActions.showSideNavBar());
        },
        onCreateCQATransaction: function () {
            dispatch(ui_common_1.gradeBenchPanelActions.createCQATransaction);
        },
        onDeleteCQATransaction: function () {
            dispatch(ui_common_1.gradeBenchPanelActions.deleteCQATransaction);
        }
    };
};
exports.mapDispatchToCodeBenchProps = mapDispatchToCodeBenchProps;
//# sourceMappingURL=code-bench-component-utilities.js.map